import ApiGateway from '../../aws/api-gateway/ApiGateway';
import { Sources } from '../sourceSettings';
const debug = process.env.REACT_APP_DEBUG && false;
const source = Sources.S3Athena;
const pathPrefix = source === Sources.S3Athena ? 'bi' : 'timestream';
const lNSMetricsQueryPath = 'lnsBucketedMetrics';
export const geLNSMetrics = async ({ duration, units, sortOrder, fromDateValue, toDateValue, applicationServerSks, NextToken, }) => {
    const path = `/${pathPrefix}/${lNSMetricsQueryPath}`;
    const params = {
        duration,
        units,
        sortOrder,
        fromTimestampMs: fromDateValue.unix() * 1000,
        toTimestampMs: toDateValue.unix() * 1000,
        lnsSKs: applicationServerSks,
        NextToken,
    };
    let res = { err: null, data: null };
    const queryRes = (await ApiGateway.post(path, params, 'NetworkApi'));
    if (queryRes.err) {
        res.err = queryRes.err;
    }
    if (queryRes.NextToken) {
        res.NextToken = queryRes.NextToken;
    }
    if (queryRes.data) {
        res.data = queryRes.data;
        debug && console.log('LNS Metrics data', queryRes);
    }
    return res;
};
const maxIterations = 100;
export const iterateGetLNSMetrics = async (iteration = 0, queryRequest, previousRes = { err: null, data: null, NextToken: undefined }) => {
    const { duration, units, sortOrder, applicationServerSks, fromDateValue, toDateValue, NextToken: NextTokenIn } = queryRequest;
    const { err: iterationErr, data: iterationData, NextToken, } = await geLNSMetrics({ duration, units, sortOrder, applicationServerSks, fromDateValue, toDateValue, NextToken: NextTokenIn });
    if (iterationErr) {
        debug && console.log('iterateGetLNSMetrics err', iterationErr?.message);
        previousRes.err = iterationErr;
    }
    else if (iterationData) {
        previousRes.data = [...(previousRes.data ?? []), ...iterationData];
        if (NextToken) {
            if (iteration < maxIterations) {
                if (iterationData?.length === 0) {
                    console.log(`API returned zero results but a NextToken`);
                }
                previousRes = await iterateGetLNSMetrics(iteration + 1, { ...queryRequest, NextToken }, previousRes);
            }
            else {
                console.log(`iterateGetLNSMetrics reached max iterations ${maxIterations}`);
            }
        }
    }
    return previousRes;
};
